export const GETDATASUCCESS = "GETDATASUCCESS"
export const GETDATAREQUEST = "GETDATAREQUEST"
export const GETDATAFAILURE = "GETDATAFAILURE"